<template>
    <b-modal id="accesoCuentaModal" v-model="accessModal" 
        title="Inicia sesión o crea tu cuenta" 
        no-body 
        no-gutters
        ok-only
        ok-title="Continuar"
        no-close-on-esc
        :hide-footer="!isLogged">
        <acceso-cuenta />
    </b-modal>
</template>

<script>
import accesoCuenta from '@/js/components/page/daniel/contrata-ya/acceso-cuenta'
import { mapGetters } from 'vuex';
export default {
    name: 'accesoCuentaModal',
    components: { accesoCuenta },
    data: () => {
        return {
            accessModal: false
        }
    },
    computed: {
        ...mapGetters(['isLogged'])
    },
    methods: {
        show() {
            this.accessModal = true;
        }
    }
}
</script>